import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PracticeMCQsLayer from "../components/PracticeMCQsLayer";

const PracticeMCQsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Practice MCQs" />

        {/* PracticeMCQsLayer */}
        <PracticeMCQsLayer />
      </MasterLayout>
    </>
  );
};

export default PracticeMCQsPage;
